































































import settlements from '@/store/types/settlements';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { settlementParams } from '@/store/interfaces/settlements';
import FormatDate from '@/util/classes/datesFormat';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const dateFormat = new FormatDate();

export default Vue.extend({
  name: 'LiquidationReport',
  data: () => ({
    settlement: {
      amount_cents: 0,
      amount_currency: '',
      discount_cents: 0,
      discount_currency: '',
      file_title: '',
      id: '',
      period_from: '',
      period_to: '',
      stated_commission_cents: 0,
      stated_commission_currency: '',
      stated_taxes_cents: 0,
      stated_taxes_currency: '',
      subtotal_cents: 0,
      subtotal_currency: '',
      subtotal_without_taxes_cents: 0,
      subtotal_without_taxes_currency: '',
      tip_cents: 0,
      tip_currency: '',
      total_cents: 0,
      total_currency: '',
      transactions_count: 0,
    },
    tableColumns: [
      {
        prop: 'period_from',
        label: 'Periodo desde',
        minWidth: 280,
        sortable: true,
        formatter: (row: settlementParams) => {
          return dateFormat.formatDate(row.period_from);
        },
      },
      {
        prop: 'period_to',
        label: 'Periodo hasta',
        minWidth: 280,
        sortable: true,
        formatter: (row: settlementParams) => {
          return dateFormat.formatDate(row.period_to);
        },
      },
      {
        prop: 'transactions_count',
        label: 'Transacciones',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'subtotal_cents',
        label: 'Subtotal',
        minWidth: 280,
        sortable: true,
        slotName: 'subtotal_cents',
      },
      {
        prop: 'tip_cents',
        label: 'Propina',
        minWidth: 280,
        sortable: true,
        slotName: 'tip_cents',
      },
      {
        prop: 'discount_cents',
        label: 'Descuento',
        minWidth: 280,
        sortable: true,
        slotName: 'discount_cents',
      },
      {
        prop: 'subtotal_without_taxes_cents',
        label: 'Comisionable',
        minWidth: 280,
        sortable: true,
        slotName: 'subtotal_without_taxes_cents',
      },
      {
        prop: 'stated_taxes_cents',
        label: 'Impuesto',
        minWidth: 280,
        sortable: true,
        slotName: 'stated_taxes_cents',
      },
      {
        prop: 'stated_commission_cents',
        label: 'Comisión',
        minWidth: 280,
        sortable: true,
        slotName: 'stated_commission_cents',
      },
      {
        prop: 'total',
        label: 'Total',
        minWidth: 280,
        sortable: true,
        slotName: 'total_cents',
      }
    ] as tTableColumns,
    propsToSearch: [] as tPropsToSearch,
  }),
  computed: {
    ...mapGetters({
      getAllSettlements: `settlementModule/${settlements.getters.GET_SETTLEMENTS}`,
    }),
  },
  methods: {
    ...mapActions({
      allSettlements: `settlementModule/${settlements.actions.SETTLEMENTS}`,
    }),
    rowSelect(row: settlementParams) {
      this.settlement = row;
    },
    transactionDetail() {
      this.$router.push({
        name: 'liquidation-report-list',
        params: { id: this.settlement.id, },
      });
    },
  },
});
